import React, { useEffect, useState } from 'react'
import Mousetrap from 'mousetrap'
import { ChevronDownIcon, ChevronRightIcon } from '@pocket/web-ui'
import { useSelector, useDispatch } from 'react-redux'
import { devModeToggle } from 'connectors/app/app.state'
import { Features } from './features'
import { Languages } from './languages'
import { Variants } from './variants'
import { Colors } from './colors'

import { css } from 'linaria'
import { headingSansSerif } from '@pocket/web-ui'

const devToolStyle = css`
  padding: var(--spacing100);
  position: fixed;
  bottom: var(--spacing075);
  right: var(--spacing075);
  background-color: var(--color-canvas);
  z-index: var(--zIndexModal);
  display: grid;
  grid-row-gap: var(--spacing100);
  border: 1px solid var(--color-dividerTertiary);
  border-radius: 4px;
  max-height: 97%;
  overflow-y: scroll;

  h6 {
    ${headingSansSerif};
    padding: 0 0 var(--spacing075);
    border-bottom: 1px solid var(--color-dividerTertiary);
    margin-bottom: var(--spacing050);
    position: relative;
    cursor: pointer;

    &:hover, &:active {
      color: var(--color-actionPrimaryHover);
    }

    .icon {
      position: absolute;
      right: 0;
      bottom: var(--spacing075);
    }
  }
`
export function CollapseWrapper({ title, collapsed, children }) {
  const [isCollapsed, setCollapsed] = useState(collapsed)

  const handleClick = () => setCollapsed(!isCollapsed)

  return (
    <div>
      <h6 className="san" onClick={handleClick}>
        {title}
        { isCollapsed ? <ChevronRightIcon /> : <ChevronDownIcon /> }
      </h6>
      { isCollapsed ? null : children }
    </div>
  )
}

export function DevTools() {
  const dispatch = useDispatch()

  const devMode = useSelector((state) => state.app.devMode)
  const handleKeyCombo = () => dispatch(devModeToggle())

  useEffect(() => {
    Mousetrap.bind('q a', handleKeyCombo) // Enter dev mode
    return () => Mousetrap.unbind('q a') // Clean up
  }, []) //eslint-disable-line

  return devMode ? (
    <div className={devToolStyle}>
      <Features />
      <Variants />
      <Languages />
      <Colors />
    </div>
  ) : null
}
